import React from 'react';
import type { Button as Interface } from '../../design/components';

const Spinner = () => (
  <span style={{
    display: 'inline-block', width: 14, height: 14, marginRight: 6,
    border: '2px solid currentColor', borderTopColor: 'transparent',
    borderRadius: '50%', animation: 'spin 0.6s linear infinite', verticalAlign: 'middle',
  }} />
);

export const Button: React.FC<Interface> = ({
  name, description, hidden, disabled, loading, onClick
}) => {
  return (
    <>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      <button
        type="button"
        disabled={disabled || loading}
        onClick={onClick}
        title={description}
        style={{
          display: hidden ? 'none' : undefined,
          padding: '8px 16px',
          fontSize: '16px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
        }}
      >
        {loading && <Spinner />}
        {name}
      </button>
    </>
  );
};
